import "./App.css";
import Header from "./customerpanel/components/Header";
import Dashboard from "./customerpanel/pages/DashBoard";
import Dailygen from "./customerpanel/pages/Dailygen";
import DGR from "./customerpanel/pages/DGR";
import Turbine from "./customerpanel/pages/CustomerTurbine";
import { Routes, Route } from "react-router-dom";
import "./customerpanel/css/Main.css";
function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dailygen" element={<Dailygen />} />
        <Route path="/dgr" element={<DGR />} />
        <Route path="/turbine" element={<Turbine />} />
      </Routes>
    </>
  );
}

export default App;
